import { ESPConnection } from "../espConnection";
var AccountService = /** @class */ (function () {
    function AccountService(optsConnection) {
        this._connection = new ESPConnection(optsConnection, "Ws_Account", "1.03");
    }
    AccountService.prototype.connectionOptions = function () {
        return this._connection.opts();
    };
    AccountService.prototype.VerifyUser = function (request) {
        return this._connection.send("VerifyUser", request);
    };
    return AccountService;
}());
export { AccountService };
//# sourceMappingURL=wsAccount.js.map